export default __webpack_public_path__ + "static/media/Exinitic.5b9ab23c.png";